"use strict";

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Symbol = void 0;

var enum_1 = require("./enum");

var TypePointer = function TypePointer(ptr, buf) {
  _classCallCheck(this, TypePointer);

  this.ptr = ptr;
  this.ptr32 = ptr >> 2;
  this.buf = buf;
  this.HEAP8 = new Int8Array(buf);
  this.HEAPU32 = new Uint32Array(buf);
  this.HEAP32 = new Int32Array(buf);
};

var SymbolPtr = /*#__PURE__*/function (_TypePointer) {
  _inherits(SymbolPtr, _TypePointer);

  function SymbolPtr() {
    _classCallCheck(this, SymbolPtr);

    return _possibleConstructorReturn(this, _getPrototypeOf(SymbolPtr).apply(this, arguments));
  }

  _createClass(SymbolPtr, [{
    key: "type",
    get: function get() {
      return this.HEAPU32[this.ptr32];
    }
  }, {
    key: "data",
    get: function get() {
      var len = this.HEAPU32[this.ptr32 + 2];
      var ptr = this.HEAPU32[this.ptr32 + 3];
      return Int8Array.from(this.HEAP8.subarray(ptr, ptr + len));
    }
  }, {
    key: "points",
    get: function get() {
      var len = this.HEAPU32[this.ptr32 + 5];
      var ptr = this.HEAPU32[this.ptr32 + 6];
      var ptr32 = ptr >> 2;
      var res = [];

      for (var i = 0; i < len; ++i) {
        var x = this.HEAP32[ptr32 + i * 2];
        var y = this.HEAP32[ptr32 + i * 2 + 1];
        res.push({
          x: x,
          y: y
        });
      }

      return res;
    }
  }, {
    key: "next",
    get: function get() {
      var ptr = this.HEAPU32[this.ptr32 + 8];
      if (!ptr) return null;
      return new SymbolPtr(ptr, this.buf);
    }
  }, {
    key: "time",
    get: function get() {
      return this.HEAPU32[this.ptr32 + 10];
    }
  }, {
    key: "cacheCount",
    get: function get() {
      return this.HEAP32[this.ptr32 + 11];
    }
  }, {
    key: "quality",
    get: function get() {
      return this.HEAP32[this.ptr32 + 12];
    }
  }]);

  return SymbolPtr;
}(TypePointer);

var SymbolSetPtr = /*#__PURE__*/function (_TypePointer2) {
  _inherits(SymbolSetPtr, _TypePointer2);

  function SymbolSetPtr() {
    _classCallCheck(this, SymbolSetPtr);

    return _possibleConstructorReturn(this, _getPrototypeOf(SymbolSetPtr).apply(this, arguments));
  }

  _createClass(SymbolSetPtr, [{
    key: "head",
    get: function get() {
      var ptr = this.HEAPU32[this.ptr32 + 2];
      if (!ptr) return null;
      return new SymbolPtr(ptr, this.buf);
    }
  }]);

  return SymbolSetPtr;
}(TypePointer);

var Symbol = /*#__PURE__*/function () {
  function Symbol(ptr) {
    _classCallCheck(this, Symbol);

    this.type = ptr.type;
    this.typeName = enum_1.ZBarSymbolType[this.type];
    this.data = ptr.data;
    this.points = ptr.points;
    this.time = ptr.time;
    this.cacheCount = ptr.cacheCount;
    this.quality = ptr.quality;
  }

  _createClass(Symbol, [{
    key: "decode",
    value: function decode(encoding) {
      var decoder = new TextDecoder(encoding);
      return decoder.decode(this.data);
    }
  }], [{
    key: "createSymbolsFromPtr",
    value: function createSymbolsFromPtr(ptr, buf) {
      if (ptr == 0) return [];
      var set = new SymbolSetPtr(ptr, buf);
      var symbol = set.head;
      var res = [];

      while (symbol !== null) {
        res.push(new Symbol(symbol));
        symbol = symbol.next;
      }

      return res;
    }
  }]);

  return Symbol;
}();

exports.Symbol = Symbol;